import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWarning = props => (
  <SvgIcon {...props} viewBox="0 0 24 21">
    <path d="m0 21h24l-12-21-12 21zm13-3h-2v-2h2v2zm0-4h-2v-5h2v5z" />
  </SvgIcon>
);

export default IconWarning;



// WEBPACK FOOTER //
// ./src/components/icons/IconWarning.js